import { render, staticRenderFns } from "./GraficaAvanceEstimaciones.vue?vue&type=template&id=72b2e454&scoped=true&"
import script from "./GraficaAvanceEstimaciones.vue?vue&type=script&lang=js&"
export * from "./GraficaAvanceEstimaciones.vue?vue&type=script&lang=js&"
import style0 from "./GraficaAvanceEstimaciones.vue?vue&type=style&index=0&id=72b2e454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2e454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VChip,VContainer,VDivider,VSimpleTable})
